import { render, staticRenderFns } from "./PanelCurrentModel.vue?vue&type=template&id=1ac90cce&lang=pug&"
import script from "./PanelCurrentModel.vue?vue&type=script&lang=js&"
export * from "./PanelCurrentModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports